import { getMonthStartEnd } from '../../function/replaceString';
import { DBMonthlyOrderAmount } from '../chart/DBMonthlyOrderAmount';
import { ProdAmountPriceBarChart } from '../chart/ProdAmountPriceBarChart';
import { ProdAmountPriceChartProvider } from '../chart/provider/ProdAmountPriceChartProvider';

export const MonthlyOrderAmount = () => {
  const { startDash, endDash } = getMonthStartEnd(new Date());
  const fetchCount = 1;
  return (
    <ProdAmountPriceChartProvider
      fetchCount={fetchCount}
      startDt={startDash}
      endDt={endDash}
    >
      <DBMonthlyOrderAmount />
    </ProdAmountPriceChartProvider>
  );
};
